<template>
  <footer
    class="text-light font-weight-bold bg-green"
    style="background-color:#0599A9; margin-top:30px;"
  >
    <div class="container-fluid">
      <div class="p-md-5">
        <div class="row">
          <!--          <div class="col-md-4">-->
          <!--            <h4 class="font-weight-bold">Ghana Ladies In Tech</h4>-->
          <!--&lt;!&ndash;            <p class>&ndash;&gt;-->
          <!--&lt;!&ndash;              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean elit adipiscing lectus mauris. Convallis facilisis tellus diam aliquam. Quis lorem tellus sed ipsum adipiscing. Congue elementum sed et ullamcorper feugiat accumsan pharetra, faucibus. Ut aliquet amet et, consequat. Gravida nisl interdum mattis lectus mauris. Sed justo, est ut sit. Mattis sit habitasse faucibus dignissim id amet adipiscing pellentesque. Consectetur enim praesent bibendum nunc. Nulla nulla in nunc varius tristique. Vitae bibendum fermentum, tellus, sagittis arcu arcu, varius. Tristique egestas in amet ultrices at feugiat. Hac varius sit turpis sit. Viverra tincidunt quis aliquet dui eleifend enim.&ndash;&gt;-->
          <!--&lt;!&ndash;              Dui feugiat sagittis varius dolor.&ndash;&gt;-->
          <!--&lt;!&ndash;            </p>&ndash;&gt;-->
          <!--          </div>-->
          <div class="col-md-2 col-4 offset-md-3">
            <div class>
              <h4 class="font-weight-bold">Support</h4>
              <p>
                <a href="#" class="text-light">FAQs</a>
              </p>
              <p>
                <a href="#" class="text-light">How It Works</a>
              </p>
              <p>
                <router-link to="/activities" class="text-light"
                  >Activities</router-link
                >
              </p>
            </div>
          </div>
          <div class="col-md-2 col-5">
            <h4 class="font-weight-bold">Links</h4>
            <p>
              <a class="text-light" href="#">About Us</a>
            </p>
            <p>
              <a class="text-light" to="/membership application">Become A Member</a>
            </p>
            <p>
              <a class="text-light" href="#">Activities</a>
            </p>
            <p>
              <router-link class="text-light" to="/contact-us"
                >Contact Us</router-link
              >
            </p>
          </div>
          <div class="col-md-2 col-3">
            <div class="pl-md-3">
              <h4 class="font-weight-bold">Follow Us</h4>
              <p>
                <a class="text-light" href="https://www.facebook.com/Ghana-Ladies-In-Tech-102540341477700" target="_blank">Facebook</a>
              </p>
              <p>
                <a class="text-light" href="https://twitter.com/gh_ladiesintech" target="_blank">Twitter</a>
              </p>
              <p><a href="https://www.linkedin.com/showcase/ghana-ladies-in-tech/?viewAsMember=true" target="_blank">LinkedIn</a></p>
              <p><a href="https://www.instagram.com/ghanaladiesintech/" target="_blank">Instagram</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-3" style="background: #000000">
      <div class="container-fluid">
        <div class="row font-weight-light">
          <div class="col-md-12">
            <p style="font-size:20px;" class="text-xs-center text-sm-center">
              &copy; Ghana Tech Lab {{ currentYear() }}
            </p>
          </div>
          <!-- <div class="col-md-6">
            <div class="text-sm-center text-md-right text-xs-center">
              <a href="#">
                <i class="fa fa-facebook mr-2 cursor-pointer" style="font-size:25px;"></i>
              </a>
              <a href="#">
                <i class="fa fa-instagram mr-2 cursor-pointer" style="font-size:25px;"></i>
              </a>
              <a href="#">
                <i class="fa fa-twitter mr-2 cursor-pointer" style="font-size:25px;"></i>
              </a>
              <a href="#">
                <i class="fa fa-linkedin cursor-pointer" style="font-size:25px;"></i>
              </a>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "downFooter",
  methods: {
    currentYear() {
      var d = new Date();
      var n = d.getFullYear();
      return n;
    }
  }
};
</script>
